import React, { useState } from 'react';

//Import Custom Component
import ProductTypeOne from '../../../../features/product/product-type-one';

function FeaturedProductsOne ( props ) {
	const { addClass = "", dataProduct } = props;

	const [showRelatedProducts, setShowRelatedProducts] = useState(false);

	const filtered = dataProduct.product ? dataProduct.product.related.filter(a => (a.product && a.product.product_active === 1)) : dataProduct.related.filter(a => (a.product && a.product.product_active === 1));

	return (
		<section className={ `featured-section ${addClass}` }>
			<span style={{fontSize:"18px"}}>Popularne wśród klientów zamawiających ten produkt.</span>
			<div className="row pt-4">
				{
					!showRelatedProducts ? 
						filtered.slice(0, 6).map((item, index) => 
							item.product.product_active ? 
								<ProductTypeOne
									addClass="inner-quickview inner-icon col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6"
									product={ item.product }
									key={ "product-type-4" + index }
								/>
							: null
						)
					:
					filtered.slice(0, 70).map((item, index) => 
						item.product.product_active ? 
							<ProductTypeOne
								addClass="inner-quickview inner-icon col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6"
								product={ item.product }
								key={ "product-type-4" + index }
							/>
						: null
					)
				}
			</div>
			{
				(dataProduct.related && dataProduct.related.length >= 6) || (dataProduct.product && dataProduct.product.related.length >= 6) ? 
					<div className="row">
						<div className="col-lg-12 text-center">
							{
								!showRelatedProducts ? 
									<button className="btn btn-sm btn-primary" onClick={() => setShowRelatedProducts(true)}>Zobacz wszystkie ({filtered.length})</button>
								: <button className="btn btn-sm btn-primary" onClick={() => setShowRelatedProducts(false)}>Ukryj wszystkie ({filtered.length})</button>
							}
						</div>
					</div>
				: null
			}
		</section>
	)
}

export default FeaturedProductsOne;